/**************
Scripts forTribe Events 
***************/

jQuery(document).ready(function($){

	/**
	 * On Tribe Events search / filter success, scroll down to content
	 */
	if (typeof trine_ev !== "undefined") {
		$( tribe_ev.events ).on('tribe_ev_ajaxSuccess', function(){
			$('#tribe-events-content').smoothScroll(); 
		});
	}
	
});